import baseAPI from '../services/api-service';

const getSettings = async (sessionToken) => {
  if (!sessionToken) return undefined;

  const apiService = baseAPI(sessionToken);

  return apiService.get(`settings`);
};

const updateSettings = async (sessionToken, newSettings) => {
  if (!sessionToken) return undefined;

  const apiService = baseAPI(sessionToken);

  return apiService.put(`settings`, { settings: newSettings });
};

const functions = {
  getSettings,
  updateSettings,
};

export default functions;
